import { Spin } from 'antd'
import React, { ButtonHTMLAttributes, FormEvent } from 'react'
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string
  isLoading?: boolean
}

const styleClassNames =
  '  bg-rw-color rounded-[24px] w-[400px] h-[47px] text-white uppercase hover:text-cyan-600 hover:bg-white hover:border-solid hover:border-[1px] hover:border-cyan-600 hover:ease-in-out  duration-500'
export const FormButton = (props: ButtonProps) => {
  const preventEvent = (e: FormEvent<HTMLButtonElement>) => e.preventDefault()
  const { isLoading, onSubmit, onClick, className, title, ...restProps } = props

  return (
    <button
      onSubmit={isLoading ? preventEvent : onSubmit}
      onClick={isLoading ? preventEvent : onClick}
      {...restProps}
      className={`${className ? '' : styleClassNames}`}
    >
      {isLoading ? <Spin /> : title}
    </button>
  )
}
